import React, { Component } from "react";
import { connect } from "react-redux";
import "react-input-range/lib/css/index.css";
import { SlideToggle } from "react-slide-toggle";
import { filterBrand, filterColor, filterPrice } from "../../../actions";
import {
  getValueFromLanguageObject,
  getColorCodeBasedOnKey,
} from "../../../store";
import { withRouter } from "react-router-dom";

class Filter extends Component {
  state = {
    expandedCategories: {}, // Track which categories are expanded
  };

  componentDidMount() {
    // Auto-expand parent category if a subcategory is selected
    this.autoExpandParentCategory();
  }

  componentDidUpdate(prevProps) {
    // Auto-expand parent category if subcategory selection changes or subcategories are loaded
    if (
      prevProps.subCategoryId !== this.props.subCategoryId ||
      prevProps.subCategories !== this.props.subCategories
    ) {
      this.autoExpandParentCategory();
    }
  }

  autoExpandParentCategory = () => {
    const { subCategoryId, subCategories } = this.props;

    if (subCategoryId && subCategories && subCategories.length > 0) {
      // Find the subcategory that matches the selected subCategoryId
      const selectedSubcategory = subCategories.find(
        (sub) => sub.id === subCategoryId
      );

      if (selectedSubcategory && selectedSubcategory.parentId) {
        // Find the parent category ID (handle trailing characters)
        const parentId = selectedSubcategory.parentId.trim();

        this.setState((prevState) => {
          const newExpandedCategories = {
            ...prevState.expandedCategories,
            [parentId]: true,
          };
          return { expandedCategories: newExpandedCategories };
        });
      }
    }
  };

  closeFilter = () => {
    document.querySelector(".collection-filter").style = "left: -365px";
  };

  // Toggle subcategory expansion for a specific category
  toggleSubcategories = (categoryId) => {
    this.setState((prevState) => ({
      expandedCategories: {
        ...prevState.expandedCategories,
        [categoryId]: !prevState.expandedCategories[categoryId],
      },
    }));
  };

  // Check if a category is expanded
  isCategoryExpanded = (categoryId) => {
    return this.state.expandedCategories[categoryId] || false;
  };

  // colorHandle(event, color) {
  //   var elems = document.querySelectorAll(".color-selector ul li");
  //   [].forEach.call(elems, function(el) {
  //     el.classList.remove("active");
  //   });
  //   event.target.classList.add("active");
  //   this.props.filterColor(color);
  // }

  render() {
    let styles = {
      Padding: "0",
      border: "none",
      background: "none",
    };

    const {
      categories,
      subCategories,
      categoryId,
      subCategoryId,
      onClickOfParentCategory,
      onClickOfSubCategory,
      clearFilterOnClickOfAll,
    } = this.props;

    return (
      <>
        {categories && categories.length > 0 && (
          <div
            className="card mb-3"
            // collection-filter-block // Removed class
          >
            {/*brand filter start*/}
            <div className="collection-mobile-back card-body">
              <span
                className="filter-back"
                onClick={(e) => this.closeFilter(e)}
              >
                <i className="fa fa-angle-left" aria-hidden="true" />{" "}
                {getValueFromLanguageObject("str_back")}
              </span>
            </div>

            {/* // Category */}

            <SlideToggle>
              {({ onToggle, setCollapsibleElement }) => (
                <div className="collection-collapse-block card-body">
                  <h3 className="collapse-block-title mt-0" onClick={onToggle}>
                    {getValueFromLanguageObject("str_category")
                      ? getValueFromLanguageObject("str_category")
                      : "category"}
                  </h3>
                  <div
                    className="collection-collapse-block-content"
                    ref={setCollapsibleElement}
                  >
                    <div
                      className="collection-brand-filter"
                      style={{
                        background: "none", // Remove sidebar bg
                        borderRadius: "0", // Remove sidebar rounding
                        boxShadow: "none", // Remove sidebar shadow
                        padding: "0",
                        minWidth: "220px",
                        margin: "0",
                        border: "none",
                      }}
                    >
                      <div value={categoryId}>
                        {/* ALL row */}
                        <div className="custom-control custom-checkbox collection-filter-checkbox pl-0 mb-2">
                          <div className="category-style">
                            <div
                              className="table-style d-flex flex-nowrap"
                              style={{ width: "100%" }}
                            >
                              <div
                                onClick={clearFilterOnClickOfAll}
                                style={{ cursor: "pointer" }}
                                className="d-flex flex-nowrap w-100"
                              >
                                <div
                                  className={
                                    categoryId === "" ? "td-style fw-bold" : ""
                                  }
                                  style={{
                                    width: "100%",
                                    minHeight: "40px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    padding: "0 18px",
                                    borderRadius: "16px",
                                    fontSize: "14px",
                                    color: categoryId === "" ? "#fff" : "#222",
                                    background:
                                      categoryId === "" ? "#FF6A00" : "#f3f6fa",
                                    fontWeight: categoryId === "" ? 700 : 500,
                                    boxShadow: "none",
                                    border: "none",
                                    transition: "background 0.2s",
                                  }}
                                >
                                  {getValueFromLanguageObject("str_all") ||
                                    "ALL"}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {categories.map((category, index) => (
                          <div
                            key={index}
                            className="custom-control custom-checkbox collection-filter-checkbox pl-0 mb-2"
                          >
                            <div className="category-style">
                              <div
                                className="table-style d-flex flex-nowrap"
                                style={{ width: "100%" }}
                              >
                                <div
                                  onClick={() => {
                                    if (category.totalsubcategories > 0) {
                                      this.toggleSubcategories(category.id);
                                    } else {
                                      onClickOfParentCategory(category);
                                    }
                                  }}
                                  style={{ cursor: "pointer" }}
                                  className="d-flex flex-nowrap w-100"
                                >
                                  <div
                                    className={
                                      categoryId === category.id
                                        ? "td-style fw-bold"
                                        : ""
                                    }
                                    style={{
                                      width: "100%",
                                      minHeight: "40px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "flex-start",
                                      padding: "0 18px",
                                      borderRadius: "16px",
                                      fontSize: "14px",
                                      color:
                                        categoryId === category.id
                                          ? "#fff"
                                          : "#222",
                                      background:
                                        categoryId === category.id
                                          ? "#FF6A00"
                                          : "",
                                      fontWeight:
                                        categoryId === category.id ? 700 : 500,
                                      boxShadow: "none",
                                      border: "none",
                                      transition: "background 0.2s",
                                    }}
                                  >
                                    {category.name}
                                    {category.totalsubcategories > 0 && (
                                      <span
                                        className="badge text-white ml-2"
                                        style={{
                                          fontSize: "13px",
                                          verticalAlign: "middle",
                                          background:
                                            categoryId === category.id
                                              ? "#FB8C00"
                                              : "#FF6A00",
                                          borderRadius: "10px",
                                          marginLeft: "8px",
                                          fontWeight: 600,
                                          padding: "2px 8px",
                                        }}
                                      >
                                        {category.totalsubcategories}
                                      </span>
                                    )}
                                  </div>
                                  {category.totalsubcategories > 0 && (
                                    <div
                                      className="th-style"
                                      style={{
                                        width: "28px",
                                        textAlign: "right",
                                      }}
                                    >
                                      <i
                                        className={`fa ${
                                          this.isCategoryExpanded(category.id)
                                            ? "fa-angle-down"
                                            : "fa-angle-right"
                                        }`}
                                        aria-hidden="true"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          this.toggleSubcategories(category.id);
                                        }}
                                        style={{
                                          cursor: "pointer",
                                          fontSize: "18px",
                                          color: "#888",
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            {subCategories &&
                              Array.isArray(subCategories) &&
                              subCategories.length > 0 &&
                              this.isCategoryExpanded(category.id) && (
                                <div
                                  style={{
                                    marginLeft: "12px",
                                    marginTop: "4px",
                                    borderLeft: "2px solid #FFE0B2",
                                    paddingLeft: "4px",
                                  }}
                                >
                                  {subCategories
                                    .filter(
                                      (subcategory) =>
                                        subcategory.parentId &&
                                        subcategory.parentId.startsWith(
                                          category.id
                                        )
                                    )
                                    .map((subcategory, idx) => (
                                      <div
                                        key={idx}
                                        className="custom-control custom-checkbox pl-0 mb-1"
                                      >
                                        <div className="subcategory-style">
                                          <div
                                            className="table-style d-flex flex-nowrap"
                                            style={{ width: "100%" }}
                                          >
                                            <div
                                              className={
                                                subCategoryId === subcategory.id
                                                  ? "td-style subActive-style fw-bold"
                                                  : ""
                                              }
                                              style={{
                                                width: "100%",
                                                padding: "9px 16px",
                                                borderRadius: "14px",
                                                fontSize: "15px",
                                                cursor: "pointer",
                                                background:
                                                  subCategoryId ===
                                                  subcategory.id
                                                    ? "#FFE0B2"
                                                    : "#f8fafc",
                                                color:
                                                  subCategoryId ===
                                                  subcategory.id
                                                    ? "#FB8C00"
                                                    : "#222",
                                                fontWeight:
                                                  subCategoryId ===
                                                  subcategory.id
                                                    ? 700
                                                    : 500,
                                                boxShadow:
                                                  subCategoryId ===
                                                  subcategory.id
                                                    ? "0 2px 8px rgba(255,167,38,0.10)"
                                                    : "none",
                                                border: "none",
                                                transition: "background 0.2s",
                                              }}
                                              onClick={() => {
                                                onClickOfSubCategory(
                                                  subcategory
                                                );
                                              }}
                                            >
                                              {subcategory.name}
                                              {/* <span
                                                  className="badge text-white ml-2"
                                                  style={{
                                                    fontSize: "12px",
                                                    verticalAlign: "middle",
                                                    background: subCategoryId === subcategory.id ? "#FB8C00" : "#FF6A00",
                                                    borderRadius: "8px",
                                                    marginLeft: "8px",
                                                    fontWeight: 600,
                                                    padding: "2px 7px"
                                                  }}
                                                >
                                                  {subcategory.totalproducts}
                                                </span> */}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                </div>
                              )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </SlideToggle>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
  filterBrand,
  filterColor,
  filterPrice,
})(withRouter(Filter));
